import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import pengajuanTagihanBiayaLainnyaService from "../../services/pengajuanTagihanBiayaLainnyaService";
import Cookies from "js-cookie";

export const initialState = {
    loading_pengajuan_tagihan_biaya_lainnya: false,
    data_pengajuan_tagihan_biaya_lainnya: [],
    showMessage:false,
    message:'',
}


export const getDataPengajuanTagihanBiayaLainnya = createAsyncThunk('pengajuan_tagihan_biaya_lainnya/data',async (data, { rejectWithValue }) => {
    try {
        const response = await pengajuanTagihanBiayaLainnyaService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const pengajuanTagihanBiayaLainnyaSlice = createSlice({
    name: 'pengajuan_tagihan_biaya_lainnya',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_pengajuan_tagihan_biaya_lainnya = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPengajuanTagihanBiayaLainnya.fulfilled, (state, action) => {
                state.loading_pengajuan_tagihan_biaya_lainnya = false
                state.data_pengajuan_tagihan_biaya_lainnya = action.payload??[]
            })
            .addCase(getDataPengajuanTagihanBiayaLainnya.pending, (state) => {
                state.loading_pengajuan_tagihan_biaya_lainnya = true
            })
            .addCase(getDataPengajuanTagihanBiayaLainnya.rejected, (state, action) => {
                state.loading_pengajuan_tagihan_biaya_lainnya = false
                state.data_pengajuan_tagihan_biaya_lainnya = action.payload
            })
    },
})

export const {
    showLoading,
} = pengajuanTagihanBiayaLainnyaSlice.actions

export default pengajuanTagihanBiayaLainnyaSlice.reducer
